import MasterSettingAgreement36Form from './MasterSettingAgreement36Form';

export default MasterSettingAgreement36Form;